import React, { useEffect, useState } from 'react';
import { ReactComponent as WaterIcon } from '../../Shared/svgs/water-ef-magenta.svg';
import { ReactComponent as WasteIcon } from '../../Shared/svgs/waste-ef-magenta.svg';
import { ReactComponent as ConnectivityIcon } from '../../Shared/svgs/connectivity-ef-magenta.svg';
import useConfig from '../../../lib/hooks/useConfig';
import PaymentButton from '../../Shared/PaymentButton';
import PaymentAmountChoice from '../../Shared/Payment/AmountChoice';

const ICONS = {
    Water: WaterIcon,
    Waste: WasteIcon,
    Connectivity: ConnectivityIcon,
};

export default function UtilitiesOverview({ utilities, billingBalance, tab })
{
    const [isLoading, setIsLoading] = useState(true);
    const [paymentEnabled, setPaymentEnabled] = useState(false);
    const [openPaymentAccountNumber, setOpenPaymentAccountNumber] = useState(null);
    const [paymentErrorAccountNumber, setPaymentErrorAccountNumber] = useState(null);
    const ccConfig = useConfig('card-payment-config');

    useEffect(() =>
    {
        if (ccConfig)
        {
            setPaymentEnabled(ccConfig.cardPaymentEnabled);
            setIsLoading(false);
        }
    }, [ccConfig]);

    const togglePaymentAmountChoice = (accountNumber) =>
    {
        setPaymentErrorAccountNumber(null);
        setOpenPaymentAccountNumber((current) => (current === accountNumber ? null : accountNumber));
    };

    const handlePaymentError = (accountNumber) =>
    {
        setOpenPaymentAccountNumber(null);
        setPaymentErrorAccountNumber(accountNumber);
    };

    if (!utilities?.length) return null;

    return (
        <section className="utilities-overview-card" id="utilities-overview">
            {utilities.map((utility) =>
            {
                const Icon = ICONS[utility.utilityType] ?? WaterIcon;
                const displayBalance = utility.utilityType === 'Water'
                    ? (billingBalance ?? utility.accountBalance)
                    : utility.accountBalance;
                const showPaymentButton = !isLoading && utility.utilityType === 'Water' && paymentEnabled && tab === 'WaterOverview';

                return (
                    <React.Fragment key={utility.accountNumber}>
                        <div
                            className={`utility-row${showPaymentButton ? ' utility-row--has-payment' : ''}`}
                            id={`row-${utility.utilityType.toLowerCase()}-${utility.accountNumber}`}
                        >
                            <div className="utility-col account-cell">
                                <p className="utility-label">Account</p>
                                <div className="utility-account">
                                    <Icon className="utility-icon" />
                                    <strong>{utility.accountNumber}</strong>
                                </div>
                            </div>

                            <div className="utility-col">
                                <p className="utility-label">No. of locations</p>
                                <strong>{utility.numberOfLocations ?? '—'}</strong>
                            </div>

                            <div className="utility-col">
                                <p className="utility-label">
                                    {utility.utilityType === 'Waste' ? 'No. of waste services' : 'No. of meters'}
                                </p>
                                <strong>{utility.numberOfMetersOrServices ?? '—'}</strong>
                            </div>

                            <div className="utility-col">
                                <p className="utility-label">Account balance</p>
                                <strong className={displayBalance < 0 ? 'is-credit' : ''}>
                                    {displayBalance == null ? '—' : `£${displayBalance.toFixed(2)}`}
                                </strong>
                                {showPaymentButton && (
                                    <PaymentButton
                                        enabled={displayBalance > 0}
                                        togglePaymentAmountChoice={() => togglePaymentAmountChoice(utility.accountNumber)}
                                        id={`btnPayNow-${utility.accountNumber}`}
                                    />
                                )}
                            </div>
                        </div>

                        {showPaymentButton && (
                            <div className="utility-col">
                                {openPaymentAccountNumber === utility.accountNumber && (
                                    <PaymentAmountChoice
                                        accountBalance={displayBalance}
                                        accountNumber={utility.accountNumber}
                                        onError={() => handlePaymentError(utility.accountNumber)}
                                    />
                                )}
                                {paymentErrorAccountNumber === utility.accountNumber && (
                                    <p className="text-everflow-red">Something went wrong with your payment. Please try again.</p>
                                )}
                            </div>
                        )}
                    </React.Fragment>
                );
            })}
        </section>
    );
}
